import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/attraction/',
    name: 'attraction-detail',
    component: () => import(/* webpackChunkName: "attraction" */ '../views/AttractionDetail.vue')
  },
  {
    path: '/attraction-desktop/',
    name: 'attraction-desktop',
    component: () => import(/* webpackChunkName: "attraction-desktop" */ '../views/AttractionDesktop.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
